import Model from "./base/model";

class RoadMapRequest extends Model {
  resourceName() {
    return "road_maps_requests";
  }

  fields() {
    return {
      road_map_id: "",
      request_id: "",
      priority: "",
      observation: "",
      road_map: { jsonApi: "hasOne", type: "road_maps"},
      request: { jsonApi: "hasOne", type: "request"},
    };
  }

}

export default new RoadMapRequest();
